import {WebCallService} from "@/utilities/system/services/WebCallService";
import {PathHelper} from "@/utilities/system/helpers/PathHelper";
import {ErrorLocationType, HttpType} from "@/utilities/system/enums/Enums";
import ErrorHandler from "@/utilities/system/helpers/ErrorHandler";
import {GlobalSetting} from "@/models/entities/settings/GlobalSetting";
import {EditGlobalSettingRequest} from "@/models/api/requests";

export class SettingsService {
    private webCaller: WebCallService;
    private uriHelper: PathHelper;

    constructor(){
        this.webCaller = new WebCallService();
        this.uriHelper = new PathHelper();
    }

    public async getGlobalSettings(errorLocationType:ErrorLocationType):Promise<Array<GlobalSetting>|null> {
        const uri = this.uriHelper.settings.getGlobalSettingsPath();

        const resp = await this.webCaller.HttpSend(HttpType.get, uri);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async editGlobalSetting(setting:GlobalSetting, errorLocationType:ErrorLocationType):Promise<GlobalSetting|null> {
        const uri = this.uriHelper.settings.getUpdateGlobalSettingsPath(setting.id);

        const requestBody = new EditGlobalSettingRequest(setting);

        const resp = await this.webCaller.HttpSend(HttpType.put, uri, requestBody);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }
}